var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSankeyBlue(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 19.448,
    height: 18.956,
    viewBox: "0 0 19.448 18.956",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_75029",
    "data-name": "Group 75029",
    transform: "translate(-5.5 -5.542)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_73690",
    "data-name": "Path 73690",
    d: "M11.077,42.268C7.925,40.509,5.843,41.5,5.5,41.687v.975a2.693,2.693,0,0,1,1.443-.38c.083,0,.171,0,.258.009A5.659,5.659,0,0,1,10,43.433a11.622,11.622,0,0,0,1.081-1.164Z",
    transform: "translate(0 -27.896)",
    fill: "#185edf"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_73691",
    "data-name": "Path 73691",
    d: "M44.391,64.52a16.243,16.243,0,0,0,10.95,4.921v-3.5c-.883.129-6.071.708-9.532-2.884a11.357,11.357,0,0,1-1.418,1.468Z",
    transform: "translate(-30.392 -44.943)",
    fill: "#185edf"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_73692",
    "data-name": "Path 73692",
    d: "M34.566,54.017a8.856,8.856,0,0,0,1.226-1.527q-.528-.5-1.027-.912a12.816,12.816,0,0,1-1.245,1.314q.5.5,1.047,1.125Z",
    transform: "translate(-21.897 -35.976)",
    fill: "#185edf"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_73693",
    "data-name": "Path 73693",
    d: "M12.837,28.635A11.963,11.963,0,0,0,5.5,27.508v1.007a5.633,5.633,0,0,1,.647-.032A11.212,11.212,0,0,1,11.9,30.274a16.725,16.725,0,0,0,.942-1.639Z",
    transform: "translate(0 -17.034)",
    fill: "#185edf"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_73694",
    "data-name": "Path 73694",
    d: "M44.179,38.34c-.223.3-.441.629-.653.979-.175.289-.354.562-.533.822.317.256.636.531.959.831a16.285,16.285,0,0,1,1.436-1.822c-.118-.079-.236-.16-.356-.242-.289-.2-.573-.389-.852-.566Z",
    transform: "translate(-29.299 -25.631)",
    fill: "#185edf"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_73695",
    "data-name": "Path 73695",
    d: "M57.264,47.949a8.629,8.629,0,0,0-2.1,2.026c4.189,3.212,7.993,2.638,8.6,2.517V48.655a10.1,10.1,0,0,1-6.492-.706Z",
    transform: "translate(-38.808 -33.14)",
    fill: "#185edf"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_73696",
    "data-name": "Path 73696",
    d: "M14.038,13.577c4.038-6.645,9.891-4.836,10.911-4.456V5.647c-.909-.131-8.437-.994-11.811,5.854-2.974,6.034-6.912,6.372-7.637,6.381v1.274c.682.063,5.017.214,8.538-5.579Z",
    fill: "#185edf"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_73697",
    "data-name": "Path 73697",
    d: "M15.852,34.136c3.5-5.142,8.182-3.538,9.1-3.157V27.5c-.691-.21-6.215-1.593-10.723,5.883A9.48,9.48,0,0,1,5.5,37.821v1.069a10.859,10.859,0,0,0,10.352-4.753Z",
    transform: "translate(0 -16.979)",
    fill: "#185edf"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSankeyBlue);
export default __webpack_public_path__ + "static/media/sankeyBlue.afa6fb65525e1459866f856ac7ce4321.svg";
export { ForwardRef as ReactComponent };